import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import api from "../../lib/api";
import { ClipboardCheck, CheckCircle2, ChevronRight, Flame } from "lucide-react";

const pick = (lang, hi, en) => (lang === "हिंदी" ? hi : en);

export function CheckInCard({ language, item }) {
  const navigate = useNavigate();
  const [pf, setPf] = useState(null);
  const hour = new Date().getHours();
  const slot = hour >= 4 && hour < 15 ? "morning" : "night";

  useEffect(() => {
    api.get("/data/fields").then((r) => {
      const c = (r.data || [])[0]?.center || { lat: 24.4567, lng: 74.8736 };
      api.get(`/checkin/prefill?slot=${slot}&lat=${c.lat}&lng=${c.lng}`)
        .then((res) => setPf(res.data)).catch(() => setPf(false));
    }).catch(() => {
      api.get(`/checkin/prefill?slot=${slot}`).then((res) => setPf(res.data)).catch(() => setPf(false));
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!pf) return null;

  const done = pf.slotDone;
  const light = slot === "night" && pf.alreadyLoggedToday && !done;

  const title = done
    ? pick(language, "आज का चेक-इन पूरा", "Check-in done for now")
    : light
      ? pick(language, "शाम का हाल — और कोई काम?", "Evening wrap-up — anything else?")
      : slot === "morning"
        ? pick(language, "आज का चेक-इन करें", "Do today's check-in")
        : pick(language, "शाम का चेक-इन करें", "Do the evening check-in");

  const sub = done
    ? pick(language, "बाद में और जोड़ सकते हैं", "You can add more later")
    : pick(language, "15 सेकंड में — मौसम, पानी, फसल", "15 seconds — weather, water, crops");

  return (
    <motion.button variants={item} onClick={() => navigate("/check-in")} data-testid="checkin-card"
      className={`w-full text-left rounded-[22px] p-4 mb-5 flex items-center gap-4 shadow-sm active:scale-[.99] transition-transform ${done ? "bg-[#eef7ee] border border-[#cfe6cf]" : "bg-[#1B7A3E] text-white"}`}>
      <span className={`h-12 w-12 rounded-2xl flex items-center justify-center shrink-0 ${done ? "bg-[#1B7A3E]/10" : "bg-white/15"}`}>
        {done ? <CheckCircle2 className="h-6 w-6 text-[#1B7A3E]" /> : <ClipboardCheck className="h-6 w-6 text-white" />}
      </span>
      <div className="min-w-0 flex-1">
        <p className={`font-bold text-[15px] leading-tight ${done ? "text-[#173f1e]" : "text-white"}`}>{title}</p>
        <p className={`text-xs mt-0.5 ${done ? "text-[#5b7a5f]" : "text-white/80"}`}>{sub}</p>
      </div>
      <ChevronRight className={`h-5 w-5 shrink-0 ${done ? "text-[#1B7A3E]" : "text-white/90"}`} />
    </motion.button>
  );
}
